module.exports = __webpack_public_path__ + "assets/listcolnone.5e5a75b2.svg";